import type { RefObject } from 'react';

/* MPH-474: per-filter popover widths from the Figma Filters frame (691:59394) */
export const EVO_OVERLAY_WIDTHS: Record<string, number> = {
  sort: 312,
  baggage: 304,
  stops: 304,
  times: 360,
  airports: 360,
  airlines: 360,
};
export const EVO_OVERLAY_DEFAULT_WIDTH = 360;
const PILL_GAP = 8;
const VIEWPORT_MARGIN = 8;
/* MPH-919: 64px header + 80px sticky footer (Figma) plus room for one option row. Below this the
   popover is moved up over the pill instead of being capped further, so a very short window can
   never squeeze the Reset/Apply footer out of the popover.
   Supported down to a 161px-tall window (64 + 80 + 2 * VIEWPORT_MARGIN): below that the fixed
   header and footer alone no longer fit and the footer is clipped by the container's
   overflow: hidden again. Shrinking further would mean dropping Figma's header/footer heights. */
const MIN_OVERLAY_HEIGHT = 200;

export function setEvoOverlayPosition(
  containerRef: RefObject<HTMLButtonElement | undefined>,
  overlayRef: RefObject<HTMLDivElement | null>,
  width: number = EVO_OVERLAY_DEFAULT_WIDTH
) {
  if (!containerRef.current || !overlayRef.current) return;
  const pillRect = containerRef.current.getBoundingClientRect();
  const maxLeft = window.innerWidth - width - VIEWPORT_MARGIN;
  const left = Math.max(Math.min(pillRect.left, maxLeft), VIEWPORT_MARGIN);
  /* MPH-919: cap the popover to the space left below the pill. The Figma popover is 628px tall
     (64 header + 484 content + 80 sticky footer), so it only fits on windows taller than ~840px;
     without this the Reset/Apply footer is pushed outside the viewport and becomes unreachable.
     When even MIN_OVERLAY_HEIGHT does not fit below the pill the popover is shifted up over it:
     a negative max-height would be an invalid declaration (dropped, restoring the bug) and a tiny
     positive one would clip the footer against the container's overflow: hidden. */
  const lowestTop = window.innerHeight - MIN_OVERLAY_HEIGHT - VIEWPORT_MARGIN;
  const top = Math.max(Math.min(pillRect.bottom + PILL_GAP, lowestTop), VIEWPORT_MARGIN);
  const maxHeight = Math.max(window.innerHeight - top - VIEWPORT_MARGIN, 0);
  overlayRef.current.setAttribute(
    'style',
    `
      width: ${width}px;
      top: ${top}px;
      left: ${left}px;
      max-height: ${maxHeight}px;
    `
  );
}
